import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import * as actions from "../../../../../redux/user/actions";

import type User from "../../models/User";

import ProfileForm from "../../../../../components/forms/profile-form/ProfileForm";

type Props = {
  user: ?User,
  updateUser: (params: UpdateUserObject) => Promise<void>,
  onModalClose: () => void,
  project: Project,
};

type State = {};

class ProfileModal extends Component {
  props: Props;
  state: State = {};

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>Update Profile</Modal.Title>
        </Modal.Header>
        <ProfileForm
          user={this.props.user}
          updateUser={this.props.updateUser}
          onModalClose={this.props.onModalClose}
          onDidUpdate={this.props.onModalClose}
        />
      </Modal.Dialog>
    );
  }
}

const mapStateToProps = (_state) => {
  return {};
};

export default connect(mapStateToProps, actions)(ProfileModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/profile-modal/ProfileModal.js